import { render, staticRenderFns } from "./notifications-mailings.vue?vue&type=template&id=7d1574ca&"
import script from "./notifications-mailings.vue?vue&type=script&lang=js&"
export * from "./notifications-mailings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports